import React from 'react';

import { Container, Content } from './styles';

const Home: React.FC = () => {
  return (
    <Container>
      <Content>
        <h1>Home</h1>
      </Content>
    </Container>
  );
};

export default Home;
